import { useAuth0 } from '@auth0/auth0-react'
import { ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'

export default function PendingApprovalPage() {
  const { user, logout } = useAuth0()

  const handleLogout = async () => {
    const returnTo = import.meta.env.VITE_AUTH0_LOGOUT_REDIRECT_URI || window.location.origin
    await logout({ logoutParams: { returnTo } })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-900 via-green-800 to-green-700 py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full space-y-8"
      >
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
            <ClockIcon className="h-8 w-8 text-yellow-600" />
          </div>
          <h2 className="text-3xl font-bold text-white">
            Account Pending Approval
          </h2>
          <p className="mt-2 text-sm text-green-100">
            Your membership application is under review
          </p>
        </div>
        
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="text-center space-y-6">
            <div>
              <p className="text-gray-700 mb-4">
                Hello <strong>{user?.firstName || user?.email}</strong>,
              </p>
              <p className="text-gray-600">
                Thank you for registering with Midwest Railbirds. Your account has been created 
                but is currently pending approval from our administrators.
              </p>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex items-start">
                <EnvelopeIcon className="h-5 w-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
                <div className="text-sm text-yellow-800">
                  <p className="font-medium">What happens next?</p>
                  <p className="mt-1">
                    You will receive an email notification once your account has been approved. 
                    This typically takes 1-2 business days.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-sm text-gray-500 space-y-2">
              <p><strong>Registered:</strong> {user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'Recently'}</p>
              <p><strong>Email:</strong> {user?.email}</p>
            </div>

            <div className="pt-4 border-t border-gray-200">
              <button
                onClick={handleLogout}
                className="w-full btn-secondary"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-xs text-green-100">
            Questions about your application? Contact us at{' '}
            <a href="mailto:admin@midwestrailbirds.com" className="underline">
              admin@midwestrailbirds.com
            </a>
          </p>
        </div>
      </motion.div>
    </div>
  )
}
